import {
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import React, { useImperativeHandle, useEffect, useState, useRef } from "react";
import { logoBill } from "assets/images/logo/";

import {
  doiTuongOptions,
  gioiTinhOptions,
} from "assets/constants/select-catagory-options";
import {
  birthday2Age,
  convertIosStringToDate,
  convertIosStringToDateDayjs,
  formatDateToString,
  normalizePhoneNumber,
} from "helper/common";
import "./ExamRegBill.scss";
import ReactToPrint from "react-to-print";
import { getTodayString, serviceColumns } from "./config";
import dayjs from "dayjs";
import { ReactComponent as PhoneSVG } from "assets/icons/phone-svg.svg";
import { ReactComponent as LocationSVG } from "assets/icons/location-svg.svg";
import { ReactComponent as MailSVG } from "assets/icons/mail-svg.svg";
import { ReactComponent as InternetSVG } from "assets/icons/internet-svg.svg";
import { HeaderPrintForm } from "components/common";
import SearchPatientService from "api/searchPatient";
import { FORMAT_TIME } from "types/enums";

const ExanRegBill = (props) => {
  const { modalRef } = props;
  const printRef = useRef<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [idPK, setIdPK] = useState<any>(null);
  useImperativeHandle(modalRef, () => ({
    openModal: () => {
      openModal();
    },
    closeModal: () => {
      closeModal();
    },
    setIdPK: setIdPK,
  }));
  useEffect(() => {});
  useEffect(() => {}, [isModalOpen]);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const getThanNhan = (hoTen, quanHe) => {
    if (hoTen) {
      return quanHe ? hoTen + `(${quanHe})` : hoTen;
    }
    return "";
  };

  const onPrint = async () => {
    window.print();
  };

  //fetch
  const fetchPhieuKhamIn = async (params) => {
    try {
      let response = await SearchPatientService.getPKInById(params);
      setThongTinIn(response.data);
    } catch (err) {}
  };
  useEffect(() => {
    if (idPK)
      fetchPhieuKhamIn({
        id: idPK,
      });
  }, [idPK]);
  useEffect(() => {}, [thongTinIn]);
  return (
    // <Row className="exam-reg-bill">
    <Modal
      wrapClassName=""
      centered
      open={isModalOpen}
      onCancel={closeModal}
      closable={false}
      footer={null}
      width={1000}
      destroyOnClose={true}
    >
      <div className="modal-custom-examRegBill">
        <div ref={printRef} style={{ padding: "20px", width: "210mm" }}>
          {/* <HeaderPrintForm /> */}
          <div>
            {/* <Row
            align={"middle"}
            justify={"space-between"}
            style={{padding: "0px 24px 0 8px"}}
          >
            <Col span={22}>
              <Row>
                <Typography.Text strong style={{fontSize: "20px"}}>
                  Bệnh viện chuyên khoa mắt Alina
                </Typography.Text>
              </Row>
              <Row justify={"space-between"}>
                <Col>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <PhoneSVG />
                    <Typography.Text>0866224883</Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <LocationSVG />
                    <Typography.Text>
                      Xuân Giang, Văn Giang, Hưng Yên
                    </Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <MailSVG />
                    <Typography.Text>contact@alinavn.com</Typography.Text>
                  </Row>
                </Col>
                <Col>
                  <Row style={{gap: "8px"}} align={"middle"}>
                    <InternetSVG />
                    <Typography.Text>alinavn.com</Typography.Text>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={2}>
              <Row justify={"end"}>
                <img
                  src={logoBill}
                  style={{
                    height: "32px",
                  }}
                />
              </Row>
            </Col>
            </Row> */}
            <HeaderPrintForm />
            {/* <div style={{border: "1px solid #d9d9d9"}}></div> */}
            <div>
              <Row
                style={{
                  paddingLeft: "32px",
                  paddingRight: "32px",
                }}
              >
                <Row justify={"center"}>
                  <Typography.Text
                    style={{
                      fontWeight: "800",
                      fontSize: "24px",
                    }}
                  >
                    PHIẾU ĐĂNG KÝ KHÁM BỆNH444
                  </Typography.Text>
                </Row>
                <Row>
                  <Row justify={"space-between"}>
                    <Col>
                      <Typography.Text style={{ fontWeight: "800" }}>
                        {thongTinIn?.hoTen?.toUpperCase()}
                      </Typography.Text>
                      {thongTinIn?.gioiTinh
                        ? ` - ${
                            gioiTinhOptions.find(
                              (it) => it.value === thongTinIn?.gioiTinh
                            )?.label
                          }`
                        : ""}{" "}
                      -{" "}
                      {thongTinIn?.ngaySinh
                        ? birthday2Age(thongTinIn?.ngaySinh)
                        : ""}{" "}
                      tuổi -
                      {thongTinIn?.ngaySinh
                        ? `(SN: ${formatDateToString(
                            convertIosStringToDateDayjs(thongTinIn?.ngaySinh),
                            FORMAT_TIME.dayFull
                          )})`
                        : "(SN: )"}
                      {thongTinIn?.soDienThoai
                        ? ` - ${thongTinIn.soDienThoai}`
                        : ""}
                      <Row>
                        <Typography.Text>
                          Địa chỉ: &nbsp;
                          <Typography.Text>
                            {thongTinIn?.diaChiTongHop}
                          </Typography.Text>
                        </Typography.Text>
                      </Row>
                      <Row>
                        <Typography.Text>
                          Lý do khám: &nbsp;
                          <Typography.Text>
                            {thongTinIn?.lyDoKham}
                          </Typography.Text>
                        </Typography.Text>
                      </Row>
                    </Col>
                    {/* </Col> */}

                    <Col>
                      {/* <Row> */}
                      <Typography.Text>
                        Mã bệnh nhân: &nbsp;
                        <Typography.Text strong>
                          {thongTinIn?.maBenhNhan}
                        </Typography.Text>
                      </Typography.Text>
                      {/* </Row> */}
                      <Row>
                        <Typography.Text>
                          Số điện thoại: &nbsp;
                          <Typography.Text strong>
                            {thongTinIn?.dienThoai}
                          </Typography.Text>
                        </Typography.Text>
                      </Row>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "8px" }}>
                    <Table
                      columns={serviceColumns}
                      dataSource={
                        thongTinIn
                          ? thongTinIn.dichVuDtos.map((it) => ({
                              dichVuKham: it.tenDichVu,
                              soLuong: it.soLuong,
                            }))
                          : []
                      }
                      bordered
                      style={{ width: "100%" }}
                      pagination={false}
                    />
                  </Row>
                  <Row style={{ marginTop: "8px" }}>
                    <Row justify={"end"}>
                      <Typography.Text className="date-sign">
                        {getTodayString(thongTinIn?.ngayNhapVien)}
                      </Typography.Text>
                    </Row>
                    <Row justify={"end"}>
                      {/* <Col>
                        <Space direction='vertical' size={64}>
                          <Row>
                            <Row justify={'center'}><Typography.Text strong>Bệnh nhân/Thân nhân</Typography.Text></Row>
                            <Row justify={'center'}><Typography.Text type='secondary'>(Ký và ghi rõ họ tên)</Typography.Text></Row>
                          </Row>
                          <Row justify={'center'}>
                            <Typography.Text strong>{thongTinIn?.hoTen}</Typography.Text>
                          </Row>
                        </Space>
                      </Col> */}
                      <Col>
                        <Space direction="vertical" size={32}>
                          <Row>
                            <Row justify={"center"}>
                              <Typography.Text strong>
                                Người tiếp nhận
                              </Typography.Text>
                            </Row>
                            <Row justify={"center"}>
                              <Typography.Text type="secondary">
                                (Ký và ghi rõ họ tên)
                              </Typography.Text>
                            </Row>
                          </Row>
                          <Row justify={"center"}>
                            <Typography.Text strong>
                              {thongTinIn?.nhanVienTiepNhan}
                            </Typography.Text>
                          </Row>
                        </Space>
                      </Col>
                    </Row>
                    <Row></Row>
                  </Row>
                  <Row>
                    <Typography.Text strong>Lễ tân</Typography.Text>
                  </Row>
                  <Row align={"middle"}>
                    <Col style={{ width: "84px" }}>
                      <Row>
                        <Row>
                          <div className="arrow"></div>
                        </Row>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <div className="ellipse"></div>
                      </Row>
                    </Col>
                    <Col style={{ width: "84px" }}>
                      <Row>
                        <Row>
                          <Typography.Text></Typography.Text>
                        </Row>
                        <Row>
                          <div className="arrow"></div>
                        </Row>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <div className="ellipse"></div>
                      </Row>
                    </Col>
                    <Col style={{ width: "84px" }}>
                      <Row>
                        <Row>
                          <Typography.Text></Typography.Text>
                        </Row>
                        <Row>
                          <div className="arrow"></div>
                        </Row>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <div className="ellipse"></div>
                      </Row>
                    </Col>
                    <Col style={{ width: "84px" }}>
                      <Row>
                        <Row>
                          <Typography.Text></Typography.Text>
                        </Row>
                        <Row>
                          <div className="arrow"></div>
                        </Row>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <div className="ellipse"></div>
                      </Row>
                    </Col>
                  </Row>
                </Row>
              </Row>
            </div>
          </div>
        </div>
      </div>
      <Row justify={"end"} style={{ marginTop: "8px", gap: "4px" }}>
        <Button danger onClick={closeModal}>
          HỦY
        </Button>
        <ReactToPrint
          trigger={() => {
            return (
              <Button type="primary" onClick={onPrint}>
                IN
              </Button>
            );
          }}
          content={() => printRef.current}
          onAfterPrint={closeModal}
          bodyClass="modal-custom-examRegBill"
        />
      </Row>
    </Modal>
    // </Row>
  );
};
export default ExanRegBill;
